import Promise from 'nd-promise'
import { SessionStorage } from 'utils/config'

// 缓存在内存中
export function promiseCached (fn) {
  const cache = Object.create(null)
  return function cachedFn (str) {
    let key = str
    if (typeof str === 'object') {
      key = JSON.stringify(str)
    }
    const hit = cache[key]
    return hit
      ? Promise.resolve(cache[key])
      : fn(str).then(res => {
        cache[key] = res
        return Promise.resolve(res)
      })
  }
}

// 缓存在sessionStorage中
export function promiseSessionStorageCached (fn, storageKey) {
  const cache = SessionStorage.get(storageKey) || Object.create(null)
  return function cachedFn (str) {
    let key = str
    if (typeof str === 'object') {
      key = JSON.stringify(str)
    }
    key = (fn.name || '') + key
    const hit = cache[key]
    if (hit) {
      return hit
    } else {
      cache[key] = fn(str)
      return cache[key]
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/cached.js